/**
 * @author Angel Labrada
 * @since v0.0.1
 * @date 21/11/21
 */
import React, {memo, useState, useCallback, useEffect, useMemo} from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import classNames from 'classnames';
import styles from './index.less';
import {useTranslation} from 'react-i18next';
import EditLineIcon from 'remixicon-react/EditLineIcon';
import {useHistory} from 'react-router-dom';
import SectionBox from '@/modules/templates/components/Registers/TemplateSectionsDrawer/components/SectionBox';
import {useInfinite} from '@/utils/createInfiniteHook';
import {CACHE_KEY_LIST_SECTIONS} from '@/modules/templates/contants/registers/sections';
import { useInfiniteScroll } from '@dofleini/use-scroll';
import SectionsApiService from '@/modules/templates/services/registers/SectionsApiService';
import {OperatorFilter, TermFilter} from '@dofleini/query-builder';

const SERVER_PAGE = 35;

const TemplateSections = ({entity}) => {
  const {t} = useTranslation('templates');
  const [dataSections, setDataSections] = useState([]);
  const {push} = useHistory();

  const handleEditTemplate = useCallback(() => {
    push(`/templates/manage/register-type/${entity?._id}`);
  }, [entity?._id, push]);

  const filters = useMemo(() => new OperatorFilter({
    type: 'AND', filters: [
      new TermFilter({field: 'template', value: entity?._id})
    ]
  }), [entity?._id]);

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isLoading,
    isSuccess,
    onLoadCompleted
  } = useInfinite({
    key: [CACHE_KEY_LIST_SECTIONS, filters, entity?._id],
    service: SectionsApiService.search,
    filters,
    sort: '_id',
    queryConfig: { size: Math.max(25, SERVER_PAGE) },
  });

  useInfiniteScroll({
    fromWindow: false,
    hasNext: hasNextPage && !(isFetching || isLoading),
    onLoadMore: fetchNextPage
  });

  useEffect(() => {
    if (isSuccess) {
      onLoadCompleted && onLoadCompleted(data);
      setDataSections(data);
    }
  }, [data, isSuccess, onLoadCompleted]);

  return (
    <div className={classNames('w-full', styles.wrapperEditablePreview)}>
      <div className="section-play-and-edit">
        <Button className="flex" type="primary" size="large" icon={<EditLineIcon />} onClick={handleEditTemplate}>
          <span className="ml-2">{t('templateEditor')}</span>
        </Button>
      </div>

      <div className={classNames('w-full h-full')}>
        <div className={classNames('p-4', styles.sectionsDrawerContent)}>
          {
            dataSections?.map((item) => (
              <SectionBox key={item?._id} section={item} id={'section-'+item?._id}/>
            ))
          }
          <div className="m-6 just-to-spacing" />
        </div>
      </div>
    </div>
  );
};

TemplateSections.propTypes = {
  entity: PropTypes.object,
};

export default memo(TemplateSections);

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Code component in a table cell
 * @param {String} text this is the value of the dataIndex of the table
 * @param {Object} form
 * @param {Object} initialValues
 * */
export const renderTemplateSections = (text, form, initialValues) => {

  return (
    <TemplateSections entity={initialValues}/>
  );
};
